import { ElementSizePolicyType } from '../../../element_sizing/size_policy_type';
import { SourceImageSizeSpecType } from '../../../element_sizing/source_image_size_spec_type';

const IMAGE_SIZE_MOBILE_SMALL = 300;
const IMAGE_SIZE_MOBILE_LARGE = 300;
const IMAGE_SIZE_TABLET_SMALL = 300;
const IMAGE_SIZE_TABLET_LARGE = 300;
const IMAGE_SIZE_768 = 360;
const IMAGE_SIZE_992 = 380;
const IMAGE_SIZE_1200 = 400;
const IMAGE_SIZE_1400 = 418;
const IMAGE_SIZE_1600 = 480;
const IMAGE_SIZE_2100 = 680;
const DESKTOP_IMAGE_ASPECT_RATIO = { w: 5, h: 6 };
const MOBILE_IMAGE_ASPECT_RATIO = { w: 7, h: 5 };

export const breakpoints = [375, 480, 600, 768, 992, 1200, 1400, 1600, 2100];

export const mediaSizePolicy = {
  type: ElementSizePolicyType.VARIABLE_ASPECT_RATIO,
  aspectRatios: {
    default: MOBILE_IMAGE_ASPECT_RATIO,
    600: MOBILE_IMAGE_ASPECT_RATIO,
    768: DESKTOP_IMAGE_ASPECT_RATIO,
    992: DESKTOP_IMAGE_ASPECT_RATIO,
    1200: DESKTOP_IMAGE_ASPECT_RATIO,
    1400: DESKTOP_IMAGE_ASPECT_RATIO,
    1600: DESKTOP_IMAGE_ASPECT_RATIO,
    2100: DESKTOP_IMAGE_ASPECT_RATIO
  },
  widths: {
    default: `${IMAGE_SIZE_MOBILE_SMALL}px`,
    600: `${IMAGE_SIZE_TABLET_LARGE}px`,
    768: `${IMAGE_SIZE_768}px`,
    992: `${IMAGE_SIZE_992}px`,
    1200: `${IMAGE_SIZE_1200}px`,
    1400: `${IMAGE_SIZE_1400}px`,
    1600: `${IMAGE_SIZE_1600}px`,
    2100: `${IMAGE_SIZE_2100}px`
  }
};

export const sourceMediaSizeSpec = {
  type: SourceImageSizeSpecType.ONLY_WIDTH,
  widths: {
    default: IMAGE_SIZE_MOBILE_SMALL,
    375: IMAGE_SIZE_MOBILE_LARGE,
    480: IMAGE_SIZE_TABLET_SMALL,
    600: IMAGE_SIZE_TABLET_LARGE,
    768: IMAGE_SIZE_768,
    992: IMAGE_SIZE_992,
    1200: IMAGE_SIZE_1200,
    1400: IMAGE_SIZE_1400,
    1600: IMAGE_SIZE_1600,
    2100: IMAGE_SIZE_2100
  }
};
